import { client } from "../src/sanityClient"

export async function getReviews() {
  return client.fetch(`
    *[_type == "review"]{
      _id,
      name,
      text,
      stars
    }
  `)
}